/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
// Redux Toolkit
import { useSelector } from "react-redux";
import { selectUser } from "../../store/userSlice";
// BASE Components
import BASESvgIcon from "../../../@BASE/core/BASESvgIcon";
import authRoles from "../../auth/authRoles";
// Material UI
import Button from "@mui/material/Button"
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

function FormEmptyListing(props) {
  const { entity, addEntity } = props;
  const user = useSelector(selectUser);

  return (
    <Paper className="flex flex-col flex-auto py-32 overflow-hidden items-center justify-center" elevation={0}>
      <BASESvgIcon size={32}>
        heroicons-outline:exclamation
      </BASESvgIcon>
      <Typography className="text-lg font-medium tracking-tight leading-6 truncate mt-16">
        There are no {entity}s to display.
      </Typography>
      {(authRoles.editor.includes(user.role)) ? (
        <>
          <Typography
            className="text-md font-medium"
            color="text.secondary"
          >
            To add a new {entity}, click the add button below.
          </Typography>
          <Divider className="my-16" />
          <Button
            variant="contained"
            color="secondary"
            onClick={addEntity}
            startIcon={<BASESvgIcon size={20}>heroicons-outline:plus</BASESvgIcon>}
          >
            Add {entity}
          </Button>
        </>
      ) : (
        <Typography
          className="text-md font-medium"
          color="text.secondary"
        >
          Please contact your system administrator to add new {entity}.
        </Typography>
      )}
    </Paper>
  );
}

export default FormEmptyListing;